import userUtils from 'utils/User';
import { matchContexts } from 'analytics/utils/cmsComponents';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const fmt = value => (value === null || value === undefined ? 'NULL' : String(value));

// Builds the trending-offers portion of sotV439. The full SOT variable is
// `{timestamp};{trending content half};{trending offers half}` where the
// timestamp is prepended by the Adobe Launch rule. Trending content and
// trending offers are mutually exclusive, so on a TO impression the entire
// content half is NULL and only the offers half carries data. Field order and
// sourcing mirror the iOS implementation 1:1.
const buildTrendingOffersSotFields = personalization => {
    if (!Sephora.configurationSettings?.p13ntrendingNBO?.isEnabled || !userUtils.isAnonymous() || !personalization?.isTrendingOffersEnabled) {
        return null;
    }

    const p13nData = matchContexts(personalization);
    const toABTestId = personalization?.trendingOffersABTest?.[0]?.abTestId;
    const deviceIdentifier = Storage.local.getItem(LOCAL_STORAGE.TRENDING_OFFERS_DEVICE_ID) || '';

    const fields = [
        'activeAbTestIds:NULL',
        'abTestTraffic:NULL',
        `abTestEndDate:${fmt(personalization?.trendingOffersABTest?.[0]?.abTestEndDate)}`,
        'isABTestEnabled:NULL',
        'isDefault:NULL',
        `deviceIdentifier:${deviceIdentifier || 'NULL'}`,
        'akamaiAbTestStartDate:NULL',
        'akamaiAbTestEndDate:NULL',
        'abGroup:NULL',
        'akamaiABTestID:NULL',
        // Trending offers half.
        `trendingOffersEnabled:${fmt(personalization?.isTrendingOffersEnabled)}`,
        `to_ABTest:${fmt(p13nData?.isAbTest)}`,
        `to_isDefault:${fmt(p13nData?.isDefault)}`,
        `to_isControl:${fmt(p13nData?.isControl)}`,
        `to_ABTestId:${fmt(toABTestId)}`,
        'toABStartDate:NULL'
    ];

    return fields.join(';');
};

export { buildTrendingOffersSotFields };
